import { categories } from '@/mocks/categories';

interface CategoryTabsProps {
  activeSlug: string;
  onSelect: (slug: string) => void;
  includeAll?: boolean;
}

export default function CategoryTabs({ activeSlug, onSelect, includeAll = true }: CategoryTabsProps) {
  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide flex-wrap">
      {includeAll && (
        <button
          onClick={() => onSelect('')}
          className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
            activeSlug === ''
              ? 'bg-primary-500 text-white'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200'
          }`}
        >
          全部
        </button>
      )}
      {categories.map((cat) => (
        <button
          key={cat.id}
          onClick={() => onSelect(cat.slug)}
          className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
            activeSlug === cat.slug
              ? 'bg-primary-500 text-white'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200'
          }`}
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className={`${cat.icon} text-sm`} />
          </span>
          {cat.name}
        </button>
      ))}
    </div>
  );
}